import { SuccessIcon } from '../assets';

const Success = () => {
    return (
        <div className="flex flex-col justify-center items-center pb-12 w-full h-screen">
            <SuccessIcon className="mb-10" />
            <p className="text-[32px] font-bold text-primary-500 mb-4">Sucesso!</p>
            <p className="text-[18px] font-medium">Pegue o seu Power Bank</p>
        </div>
    );
};

export default Success;
